module.exports = __webpack_public_path__ + "img/daily_date.15289096.svg";